/*
Hook to poll and display the current TOTP code for a given authenticator
*/
import { useGetAuthenticatorCodeQuery } from "../../../services/clientauth";

export type useLoginAuthenticatorCodeResult = {
    code: string
    remainingTime: number
}

export type useLoginAuthenticatorCodeOpts = {
    data: useLoginAuthenticatorCodeResult | null,
    isError: boolean,
    isLoading: boolean,
    isFetching: boolean
};

const useLoginAuthenticatorCode = (masterAccountId: string, loginId: string) : useLoginAuthenticatorCodeOpts => {
    // just poll the endpoint every 15 seconds for the code
    // it's not great by websockets are a pain (and this is not a massive feature everyone will see)
    // then SSE does not support tokens, and I don't want to get the MFA generated tokens without hitting a secure endpoint
    const { data, isError, isLoading, isFetching } = useGetAuthenticatorCodeQuery({ masterAccountId, loginId }, {
        pollingInterval: 15000,
    });

    return {
        data: data || null,
        isError,
        isLoading,
        isFetching,
    };
}

export default useLoginAuthenticatorCode;